import React from "react";
import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  Link,
  Button,
} from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import FeedbackIcon from "@mui/icons-material/Feedback";
import EmailIcon from "@mui/icons-material/Email";
import FavoriteIcon from "@mui/icons-material/Favorite";
import Footer from "../components/Footer";

const Support: React.FC = () => {
  const handleDonateClick = () => {
    window.open("https://cr8.rs/Shashi", "_blank", "noopener,noreferrer");
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Container maxWidth="md" sx={{ py: 8, flex: 1 }}>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Box
            component="img"
            src="/assets/avatar.jpeg"
            alt="Shashi Sharma"
            sx={{
              width: 180,
              height: 180,
              borderRadius: "50%",
              border: "4px solid",
              borderColor: "primary.main",
              mb: 2,
              mx: "auto",
            }}
          />
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
            Support
          </Typography>
          <Typography
            variant="body1"
            sx={{ mb: 3, lineHeight: 1.8, maxWidth: 700, mx: "auto" }}
          >
            Thanks for stopping by — this page provides a simple way to show
            appreciation for the work and resources shared across my projects
            and articles. Your support helps maintain and improve future
            content. Clicking the button below will open the external support
            page.
          </Typography>

          <Button
            variant="contained"
            size="large"
            startIcon={<FavoriteIcon />}
            onClick={handleDonateClick}
            sx={{
              backgroundColor: "#ec4899",
              "&:hover": {
                backgroundColor: "#db2777",
              },
              px: 4,
              py: 1.5,
              fontSize: "1.1rem",
            }}
          >
            Support
          </Button>
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, mt: 6 }}>
          Ways to Support
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Card>
            <CardContent>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}
              >
                <ShareIcon sx={{ color: "primary.main" }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Share the Content
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Share articles with your network on social media or with friends
                who might find them useful.
              </Typography>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}
              >
                <FeedbackIcon sx={{ color: "primary.main" }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Provide Feedback
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Send feedback, suggestions, or report issues. Your input helps
                improve the content.
              </Typography>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}
              >
                <EmailIcon sx={{ color: "primary.main" }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Get in Touch
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Feel free to reach out via email:{" "}
                <Link href="mailto:sharmashashi940@gmail.com">
                  sharmashashi940@gmail.com
                </Link>
              </Typography>
            </CardContent>
          </Card>
        </Box>

        <Typography
          variant="body1"
          sx={{ mt: 4, textAlign: "center", color: "text.secondary" }}
        >
          Thank you for your support! 🙏
        </Typography>
      </Container>
      <Footer />
    </Box>
  );
};

export default Support;
